export enum Step {
    ChooseGroup = "CHOOSE_GROUP",
    ChooseDuo = "CHOOSE_DUO",
    DefineRoles = "DEFINE_ROLES",
}

export interface StepReducedAction {
    type: "nextStep" | "previousStep" | "reset";
}

export const stepReducer = (state: Step, action: StepReducedAction) => {
    if (action.type === "reset") return Step.ChooseGroup;
    if (action.type === "nextStep") {
        switch (state) {
            case Step.ChooseGroup:
                return Step.ChooseDuo;
            case Step.ChooseDuo:
                return Step.DefineRoles;
        }
    }
    if (action.type === "previousStep")
        switch (state) {
            case Step.ChooseDuo:
                return Step.ChooseGroup;
            case Step.DefineRoles:
                return Step.ChooseDuo;
        }
    return state;
};
